import {
  API_CALL,
  REQUEST_BUYERS,
  RECEIVE_BUYERS,
  BUYERS_FAILED,
  START_BUYERS_SEARCH,
  RECEIVE_BUYERS_SEARCH_RESULTS,
  BUYERS_SEARCH_FAILED
} from "./types";

export const getBuyers = () => ({
  type: API_CALL,
  onRequest: REQUEST_BUYERS,
  onResponse: RECEIVE_BUYERS,
  onError: BUYERS_FAILED,
  payload: {
    method: 'GET',
    url: '/buyers'
  }
});

export const searchBuyers = (query) => ({
  type: API_CALL,
  onRequest: START_BUYERS_SEARCH,
  onResponse: RECEIVE_BUYERS_SEARCH_RESULTS,
  onError: BUYERS_SEARCH_FAILED,
  responseKey: 'results',
  payload: {
    method: 'GET',
    url: `/buyers/search/${query}`
  },
  query
});

export const setBuyersSearchResults = (results, query) => ({
  type: RECEIVE_BUYERS_SEARCH_RESULTS,
  results
});
